var map = {
	"./i18n/options.i18n.it-it.js": "A1DU",
	"./i18n/ors-dictionary.i18n.it-it.js": "bgs9",
	"./i18n/ors-map-filters.i18n.it-it.js": "BvXr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d7RZ";